<template>
  <AbaFiltro v-if="!loading" :titulo="titulo">
    <unicom-autocomplete
      style="padding-bottom: 32px"
      mostrarIconeExcluir
      colorPlaceholder="#9E9E9E"
      placeholder="Status do prestador"
      v-model="objetoFiltro.statusPrestador.descricao"
      @index="
        index => selecionarChave(index, 'statusPrestador', listaStatusPrestador)
      "
      :items="listaStatusPrestador.map(e => e.descricao)"
    />
    <unicom-campo-calendario-v3
      fecharClique
      regrasValidacao="validacaoMes"
      :duploClique="false"
      v-model="objetoFiltro.competencia"
      placeHolder="Competência"
      mostrarIconeExcluir
      :componentesAtivos="['Meses', 'Anos']"
    />
    <template slot="botao">
      <unicom-botao @click="proximaAba" :largura="360" :altura="40">
        CONTINUAR
      </unicom-botao>
    </template>
  </AbaFiltro>
  <unicom-spinner
    v-else
    style="
      min-height: 450px;
      display: flex;
      flex-flow: wrap column;
      justify-content: center;
    "
    :tamanhoLoading="62"
    :tamanhoLinha="7"
    :velocidade="0.5"
    :marginTopTexto="30"
    mensagem="Carregando..."
  />
</template>

<script>
import AbasMixin from "../AbasMixin";
import AbaFiltroMixin from "../AbaFiltroMixin";

export default {
  mixins: [AbasMixin, AbaFiltroMixin],
  data() {
    let listaStatusPrestador = [];

    return {
      listaStatusPrestador
    };
  },
  beforeMount() {
    this.inicializarStatusPrestador();
  },
  methods: {
    inicializarStatusPrestador() {
      this.loading = true;
      this.sleep(500).finally(() => {
        this.getListaStatusPrestadores()
          .then(res => {
            this.listaStatusPrestador = res.data;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>

<style></style>
